export default {
  P: 'PSC',
  R: 'PIR',
  E: 'EVAL',
  A: 'AFQ',
};
